import React from 'react';

export const VideoBanner = () => {
    return (
        <div className="tour-detail-video" style={{ backgroundImage: 'url(/images/tour_detail_video_bg.jpg)' }}>

            <button className="video-play">
                <img src="/images/icons/icon-video-play.png" alt="play icon" />
            </button>
            <ul className="video-navigation">
                <li>
                    <button><img src="/images/icons/icon-video-play-small.png" alt="icon-video-play-small" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-sound.png" alt="icon-video-sound" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-location.png" alt="icon-video-location" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-view-tour.png" alt="icon-video-view-tour" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-view.png" alt="icon-video-view" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-share.png" alt="icon-video-share" /></button>
                </li>
                <li>
                    <button> <img src="/images/icons/icon-video-info.png" alt="icon-video-info" /></button>
                </li>
                <li>
                    <button><img src="/images/icons/icon-video-full-screen.png" alt="icon-video-full-screen" /></button>
                </li>
            </ul>
        </div>
    )
}